import React from 'react';
import {formatCartElementDate} from "../../utils/dateTimeUtils";
import CartElementConfirmation from "./CartElementConfirmation";
import { Plural, useLingui } from '@lingui/react/macro';

function CartElementTacConfirmation(props) {
    const entry = props.entry;
    const nrGuests = entry.nrAdults + entry.nrChildren;

    const {t} = useLingui();

    return (
        <CartElementConfirmation
            title={entry.name}
            day={`${t({id: "on_day"})} ${entry.dayNr} (${formatCartElementDate(entry.date)})`}
            time={`${t({id: "time"})} ${entry.time}`}
            people={<Plural id="x_people" value={nrGuests} one='# person' other="# people" />}
            price={entry.price}
            strikePrice={props.strikePrice}
        />

    )
}

export default CartElementTacConfirmation;